import {
  AfterViewInit,
  ViewChild,
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  Renderer2
} from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { Utilities, DateUtilities } from '@approot/utilities';

@Component({
  selector: 'app-alerts-parameters',
  templateUrl: './alerts-parameters.component.html',
  styleUrls: ['./alerts-parameters.component.scss']
})
export class AlertsParametersComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  fixingOutcomeForm: FormGroup;
  datesForm: FormGroup;
  selectedFixingIndex: number = null;
  selectedDateIndex: number = null;
  showEntities = true;
  dates: string[];
  identifiers: string[];
  currentClickedFixingRowRef;
  @Input() fixingOutcomeSelected: boolean;
  @Input() parametersFormGroup: FormGroup;
  @Input() entities: string[];
  @Input() parameters: {
    longName: string;
    placeHolder: string;
    shortName: string;
    type: string;
    options?: string[];
  }[] = [];
  @Input() showModal = false;
  @Output() modalOpenStatusChanged = new EventEmitter();

  @ViewChild('divToScrollFixings', { static: false })
  divToScrollFixings: ElementRef;
  @ViewChild('divToScrollDate', { static: false })
  divToScrollDate: ElementRef;
  constructor(private renderer: Renderer2) {}

  ngOnInit() {
    this.datesForm = new FormGroup({
      datesArray: new FormArray([])
    });

    this.dates = [];
  }

  ngOnDestroy(): void {
    this.showModal = false;
    this.fixingOutcomeSelected = false;
  }

  ngAfterViewInit() {
    this.parameters.forEach(parameter => {
      switch (parameter.type) {
        case 'date':
          if (this.parametersFormGroup.get(parameter.shortName)) {
            const dateInput = document.getElementById(parameter.shortName);

            this.renderer.setProperty(
              dateInput,
              'value',
              this.parametersFormGroup.get(parameter.shortName).value
            );
          }
          this.dates = [...this.parametersFormGroup.get('dates').value];
          console.log(
            DateUtilities.prettyDateToDate(
              this.parametersFormGroup.get(parameter.shortName).value
            )
          );
          console.log('Dates Saved: ', this.dates);

          this.parametersFormGroup
            .get(parameter.shortName)
            .valueChanges.subscribe(val => {
              DateUtilities.onDateChanged(
                this.parametersFormGroup.get(parameter.shortName)
              ); // when date changes format it
            });
          break;
      }
    });
  }

  get datesArray() {
    return this.datesForm.get('datesArray') as FormArray;
  }

  /* addNewDate() {
    // Add date to list of dates in 2nd form
  (this.datesForm.get('datesArray') as FormArray).push(
    this.formGroupCreator(null)
  );
    console.log(this.dates);

     this.dates.push(
      DateUtilities.getDateInDashedFormat(this.parametersFormGroup.get('date').value)
    )

    this.updateScroll();
  } */

  addNewDate(date?: { status: any }) {
    const dateControl = new FormControl(date?.status ? date.status : null, [
      Validators.required
    ]);

    this.datesArray.push(dateControl);
  }

  deleteDate() {
    const dateToDelete = (this.datesForm.get('datesArray') as FormArray)
      .controls[this.selectedDateIndex] as FormGroup;

    //this.dates.splice(this.selectedDateIndex);

    (this.datesForm.get('datesArray') as FormArray).removeAt(
      this.selectedDateIndex
    );

    this.datesArray.markAsDirty();
    this.selectedDateIndex = null;
  } // Delete date from date list based on Fixing

  datesControlMaker(date) {
    return new FormControl(date ? date : '', [Validators.required]);
  }

  textBoxCaretRestrictionHandler(event, action: string) {
    // used to get the index of the item separating editable parts of text and non editable parts
    const indexLocator = Utilities.getIndexOfSeparator(event.target.value, '%');
    if (action === 'keydown') {
      Utilities.textBoxKeydownRestrictor(event, indexLocator, this.renderer);
    } else {
      Utilities.textBoxClickRestrictor(event, indexLocator, this.renderer);
    }
  }

  updateScroll() {
    setTimeout(() => {
      let e = this.divToScrollDate.nativeElement;
      e.scrollTop = e.scrollHeight;
    });
  }

  modalChanged(event) {
    this.modalOpenStatusChanged.emit(event);
  }
}
